Greenmile.Ticket = Greenmile.Ticket || {};
Greenmile.Ticket.Grid = Greenmile.Ticket.Grid || {};
Greenmile.Ticket.Grid.Menu = (function () {

  function Menu() {
    Greenmile.Grid.Menu.apply(this, arguments);

    const goToDetails = (model) => {
      const ticketId = model.get('ticket')?.id ?? model.get('id');
      const hash = "#/ticket/details/" + ticketId;

      window.location = hash;
    };

    this.menus = [
      {
        id: 1,
        name: 'ticketDetails',
        icon: 'menu-icon fa fa-file-text',
        description: Monet.I18n.getResourcesByKey('Ticket.menu.ticketDetails'),
        createAction: (model) => () => {
          this.gridMenu.removeAllMenus();
          goToDetails(model);
        }
      }
    ];

    this.getItemsToMenu = function(model) {
      const itemsToDisplay = [];
      const enabledMenus = this.getEnabledMenu();

      const findMenuAndSetToBeDisplayed = (menuEnabled) => {
        const existMenu = this.menus?.find(menu => menu.name === menuEnabled);
        if (existMenu) {
          existMenu.action = existMenu.createAction(model);
          itemsToDisplay.push(existMenu);
        }
      };

      enabledMenus.forEach(menuEnabled => {
        findMenuAndSetToBeDisplayed(menuEnabled);
      });

      return itemsToDisplay;
    };

    this.setListenersTo = grid => {
      const toShowMenu = (e, args) => this.showMenuToRowSelected(e, args);

      const nameMenus = this.menus?.map((menu) => menu.name);
      this.setEnabledMenus(nameMenus);
      
      grid.onClick.unsubscribe(toShowMenu);
      grid.onClick.subscribe(toShowMenu);
    };
  }

  return Menu;

}());